
import { Component, Vue } from "vue-property-decorator";

import StorageShippingUnitsConsultationList from "./components/StorageShippingUnitsConsultationList.vue";

@Component({
  components: { StorageShippingUnitsConsultationList },
})
export default class StorageShippingUnitsConsultation extends Vue {}
